import React, { useState } from 'react';
import { SigningStargateClient } from '@cosmjs/stargate';
import './App.css'; 

const KeplrConnect = ({ onConnect }) => {
    const [address, setAddress] = useState('');
    const [status, setStatus] = useState('');
  
    const connectWithKeplr = async () => {
      if (!window.keplr) {
        alert('Please install Keplr extension');
        return;
      }
  
      await window.keplr.enable('juno-1');
      const offlineSigner = window.getOfflineSigner('juno-1');
      const accounts = await offlineSigner.getAccounts();
      const walletAddress = accounts[0].address;
      setAddress(walletAddress);
      onConnect(walletAddress); 
    };

  const sendTip = async () => {
    if (!address) {
      alert('Please connect wallet');
      return;
    }

    const rpcEndpoint = 'https://rpc-juno.itastakers.com';
    const offlineSigner = window.getOfflineSigner('juno-1');
    const client = await SigningStargateClient.connectWithSigner(rpcEndpoint, offlineSigner);

    const recipient = 'juno1mk2yasfjljrvrxrjwj5823xh6lctkjc9aw7p56'; 
    const amountFinal = {
      denom: 'ujuno',
      amount: (69 * 1e6).toString(), 
    };

    const fee = {
      amount: [{ denom: 'ujuno', amount: '5000' }],
      gas: '200000',
    };

    const memo = "It's OK to have your eggs in one basket as long as you control what happens to that basket. - Elon Musk";

    try {
      const result = await client.sendTokens(address, recipient, [amountFinal], fee, memo);
      console.log('Transaction result:', result);
      setStatus('Tip sent successfully!');
    } catch (error) {
      if (error.message === 'Request rejected') {
        console.warn('Transaction was cancelled by the user.');
        setStatus('Transaction cancelled.');
      } else {
        console.error('Error sending tip:', error);
        setStatus('Failed to send tip.');
      }
    }
  };

  const tipWithNeta = async () => {
    if (!address) {
      alert('Please connect wallet');
      return;
    }
  
    const rpcEndpoint = 'https://rpc-juno.itastakers.com';
    const offlineSigner = window.getOfflineSigner('juno-1');
    const client = await SigningStargateClient.connectWithSigner(rpcEndpoint, offlineSigner);
  
    const recipient = 'juno1mk2yasfjljrvrxrjwj5823xh6lctkjc9aw7p56'; 
    const amountFinal = {
      denom: 'uneta', // Neta token denom
      amount: (1 * 1e6).toString(), // 1 Neta (assuming 6 decimal places)
    };
  
    const fee = {
      amount: [{ denom: 'ujuno', amount: '5000' }],
      gas: '200000',
    };
  
    const memo = "An Investment in Knowledge Pays the Best Interest - Benjamin Franklin";
  
    try {
      const result = await client.sendTokens(address, recipient, [amountFinal], fee, memo);
      console.log('Transaction result:', result);
      setStatus('Tip sent successfully!');
    } catch (error) {
      if (error.message === 'Request rejected') {
        console.warn('Transaction was cancelled by the user.');
        setStatus('Transaction cancelled.');
      } else {
        console.error('Error sending tip:', error);
        setStatus('Failed to send tip.');
      }
    }
  };

  const goBack = () => {
    window.location.href = "https://cosmosnews.zone"; 
  };

  return (
    <div className="container">
      <video autoPlay loop muted className="background-video">
        <source src="/background.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="content">
        <button className="connect-button" onClick={goBack}>Back to Website</button>
        {!address && (
          <button id="connect-button" className="connect-button" onClick={connectWithKeplr}>
            Connect Wallet
          </button>
        )}
        {address && <p>Connected Address: {address}</p>}
        <button className="tip-button" onClick={sendTip} disabled={!address}>
          Tip 69 Juno
        </button>
        <button className="connect-button" onClick={tipWithNeta} disabled={!address}>
          Tip 1 Neta
        </button>
        <p>Status: {status}</p>
      </div>
    </div>
  );
};

export default KeplrConnect;